import { EndDeviceType } from './end-device-type';
export class ManufacturerModel {
    Id: number;
    Manufacturer: string;
    Model: string;
    EndDeviceTypeId: number;
    EndDeviceType: EndDeviceType;
}
